export enum Routes {
    Home = '',
    Start = 'start',
    QuestionFlowEditor = 'question-flow-editor',
    QuestionFlowTester = 'question-flow-tester',
    UIComponents = 'ui-components',
    Pages = 'pages',
    Forbidden = 'forbidden',
    Maintenance = 'maintenance',
    PagesForbidden = 'pages/forbidden',
    PagesMaintenance = 'pages/maintenance'
}
